import React, { memo } from "react";
import BaseTextButton from "../BaseTextButton";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import { useTranslation } from "react-i18next";
import "./style.scss";

function BackButton({ to, onClick, className, title }) {
  const { t } = useTranslation();
  BackButton.propTypes = {
    to: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
  };
  const { navigateTo } = useCustomNavigate();
  const location = useLocation();
  const cls = ["btn-back"];
  if (className) cls.push(className);
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    // location.key === "default" means user landed here without prior SPA
    // navigation (direct URL, refresh, external entry). navigate(-1) in
    // that case falls out of the SPA — could end up on a previous external
    // domain (e.g., in-touch.space if user came from there). Fall back to
    // current-origin root instead.
    if (location.key === "default") {
      if (typeof window !== "undefined") {
        window.location.href = `${window.location.origin}/`;
      }
      return;
    }
    navigateTo(-1);
  };
  return (
    <BaseTextButton
      onClick={handleClick}
      icon="logout"
      className={cls.join(" ")}
      iconStyle="btn-back__icon"
      iconWrapperStyle="btn-back__icon-wrapper"
      to={to}
    >
      {title || t("back_btn")}
    </BaseTextButton>
  );
}
export default memo(BackButton);
